import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-info-required-psa',
  templateUrl: './doc-info-required-psa.component.html',
  styleUrls: ['./doc-info-required-psa.component.css']
})
export class DocInfoRequiredPsaComponent implements OnInit {
 title="Document/Information required for obtaining licence under PSA's(Regulation) act, 2005 and PSA's (Karnataka) Rules, 2008 (Annexure Form)";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/doc-info-required-psa/doc-info-required-psa.component.ts